
import {
  Stack,
  Typography,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { Link as LinkLucid } from "lucide-react";
import { CardTabsLinkStack } from "./CardTabsLink.styles";
import type { CardTabsLinkProps } from "./CardTabsLink.types";
import {
  Link
} from "../../components";

export function CardTabsLink({
  description,
  disabled,
  url_label,
  url,
  ...props
}: CardTabsLinkProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLinkClick = () => {
    if (!disabled && url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <CardTabsLinkStack
      { ...props }
      className={ disabled ? "not-allowed" : "pointer" }
      onClick={ handleLinkClick }
      style={ {
        cursor: disabled ? "not-allowed" : "pointer"
      } }
    >
      <Stack
        alignItems="center"
        gap={ 1 }
        direction="row"
        sx={ {
          ".icon": {
            "path": {
              fill: disabled ? theme.customColors.textDisabled : theme.customColors.textWidget
            }
          }
        } }

      >
        <Link
          color="primary"
          fontSize={ isMobile ? "0.875rem" : "1.125rem" }
          display={ "flex" }
          alignItems={ "center" }
          gap={ 1 }
          style={ {
            color: disabled ? theme.customColors.textDisabled : theme.customColors.textWidget,
            cursor: "inherit",
            pointerEvents: "none",
            textDecoration: "none"
          } }
        >
          { url_label }
          <LinkLucid
            size={ 20 }
            color={ disabled ? theme.customColors.textDisabled : theme.customColors.textWidget }
          />
        </Link>

      </Stack>
      {
        description ? (
          <Typography
            fontWeight={ 300 }
            fontSize={ isMobile ? "0.875rem" : "1rem" }
            lineHeight={ 11 / 8 }
            sx={ {
              color: theme.customColors.exploreCardText
            } }
          >
            { description }
          </Typography>
        ) : null
      }
    </CardTabsLinkStack>
  );
}
